import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import styles from './progressBar.scss';

const ProgressBar = ({ className, percent }) => (
  <div className={classnames(styles.bar, className)}>
    <div className={styles.progress} style={{ width: `${percent}%` }}></div>
  </div>
);

ProgressBar.propTypes = {
  className: PropTypes.string,
  percent: PropTypes.number.isRequired,
}

export { ProgressBar };


// WEBPACK FOOTER //
// ./src/elements/progressBar/progressBar.js